import React, { useEffect, useState } from "react";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import ReviewStars from "./ReviewStars";

function ReviewCard({ item }) {
  const [averageRating, setAverageRating] = useState(undefined);

  useEffect(() => {
    var catId = item.categoryId;
    fetch(
      `https://api.bazaarvoice.com/data/products.json?apiversion=5.4&passkey=ca6qyfDLykRniMh4RUK54h1OR23zYQSBtrzBvnPZ5ilGU&stats=reviews&filter=totalreviewcount:gte:1&excludeFamily=true&limit=100&filter=IsActive:eq:true&filter=CategoryAncestorId:${catId}`
    )
      .then((response) => response.json())
      .then((data) => {
        var totalReviews = 0;
        var avg = 0;

        data.Results.forEach(function (item, index) {
          totalReviews += data.Results[index].ReviewStatistics.TotalReviewCount;
          avg = data.Results[index].ReviewStatistics.AverageOverallRating;
        });
        setAverageRating(Math.round(Math.round(avg * 100) / 100));
      });
  }, [item]);

  return (
    <div className="grid md:grid-cols-1 gap-xs p-3 border text-left hide-variants hds-transition write-a-review-card">
      <div className="rounded-md overflow-hidden w-full h-full write-a-review-image">
        <Image
          image={getImage(item.productCategoryImage)}
          alt={item.productCategoryImage.alt}
        />
      </div>
      <div className="flex flex-col justify-between">
        <h4 className="font-heading uppercase font-bold pb-2 leading-tight">
          {item.categoryTitle}
        </h4>
        {averageRating !== undefined && (
          <div className="flex items-center mt-2">
            <ReviewStars
              rating={averageRating}
              starSize="15px"
              starSpacing="2px"
            />
            <span className="ml-1 text-sm">{averageRating} Reviews</span>
          </div>
        )}
      </div>
      <a
        className="fg-btn"
        href={`https://display.ugc.bazaarvoice.com/static/ThermaCELL/en_US/container.htm?bvaction=rr_submit_generic&bvcategoryId=${item.categoryId}&bvpreventClose=true`}
      >
        <button className="uppercase" type="button">
          Review
        </button>
      </a>
    </div>
  );
}

export default ReviewCard;
